
import React from 'react'
import { useSelector } from 'react-redux'

import navigation from '@/navigation'

import Header from '@/Layouts/MainLayout/components/Header'
import HeaderSubMenu from '@/Layouts/MainLayout/components/HeaderSubMenu'

import Footer from './components/Footer'

import '@/Layouts/MainLayout/MainLayout.scss'

interface Props {
  menuName: string
  subMenuName?: string
  projectId?: string
  children: any
}

const MainLayout = ({projectId, menuName, subMenuName, children }: Props) => {

  const projectsData = useSelector((state: any) => state.ProjectsReducer.data)
  const activeHomeProject = projectsData?.mine?.[0] || projectsData?.active?.[0] || projectsData?.other?.[0]
  const navigationProjectId = projectId || activeHomeProject?._id || ''

  const [ menu, submenu ] = navigation.getNavigation(
    navigationProjectId,
    menuName,
    subMenuName || '',
  )

  return (
    <div className="main-layout app-admin-wrap layout-horizontal-bar">
      <Header menu={menu} selectedProject={activeHomeProject} />
      <HeaderSubMenu submenu={submenu} />
      <div className="main-content-wrap d-flex flex-column">
        <div className="main-content-shadow" />
        <div className="main-content">
          <div className="page-content-body">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
